import React, { useState } from "react";
import styles from "./Loan.module.css";
import SaveBtn from "../../Buttons/SaveBtn";
import { Grid, InputLabel } from "@mui/material";
import NewFormTextInput from "../../FormTextInput/NewFormTextInput";
import CountryCodePhoneInput from "../../CountryCodePhoneInput/CountryCodePhoneInput";
import CancelBtn from "../../Buttons/CancelBtn";
import edufinEdit from "../../../assets/images/edufinEdit.svg";

const Profile = () => {
  const [index, setIndex] = useState(0);

  const renderIntro = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.loanHeader}>Loan(Fee Finance)</div>
        <div className={styles.subHeader}>
          Welcome to the loan feature on Nurture!
        </div>
        <div className={styles.desc}>
          We’re here to make education more accessible. Easily convert your
          academic fees into manageable monthly installments—quick, transparent,
          and stress-free.
        </div>
        <Grid xs={6} marginTop="10px">
          <SaveBtn buttonText={"Register"} onClick={() => setIndex(1)} />
        </Grid>
      </div>
    );
  };

  const renderSignup = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.loanHeader}>Signup</div>
        <div className={styles.subHeader}>Register your account</div>
        <Grid xs={6} marginTop="5px" paddingBottom="5px">
          <NewFormTextInput
            validate={true}
            label="Name"
            type={"text"}
            id={"firstName"}
            autoComplete="true"
            placeholder="eg: Alex"
            inputProps={{
              maxLength: 20,
            }}
            require={true}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel
            sx={{
              fontSize: "12px",
              color: "#142C44",
              fontWeight: "500",
              marginBottom: "5px",
              fontFamily: "Poppins",
              display: "flex",
            }}
          >
            Mobile Number
            <p style={{ margin: "0px 4px", color: "#D32F2F" }}>*</p>
          </InputLabel>
          <CountryCodePhoneInput
            // value={instituteDetails.instituteContact}
            onChange={(event: any, country: any) => {}}
            error={true}
          />
        </Grid>
        <Grid item xs={6}>
          <NewFormTextInput
            validate={true}
            label="Email ID"
            type="email"
            id={"instituteEmail"}
            placeholder="eg: contact@institute.com"
            require={true}
          />
        </Grid>
        <Grid xs={6} marginTop="10px">
          <SaveBtn buttonText={"Apply"} onClick={() => setIndex(2)} />
        </Grid>
      </div>
    );
  };

  const renderKYC = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.loanHeader}>KYC</div>
        <Grid xs={6} marginTop="10px" paddingBottom="5px">
          <NewFormTextInput
            label="Verify Aadhaar"
            placeholder="Enter Aadhaar Number"
            endButton={{
              label: "Get OTP",
              onClick: () => console.log("OTP Requested"),
            }}
          />
        </Grid>
        <Grid item xs={6} marginTop="10px">
          <NewFormTextInput
            label="Verify PAN"
            placeholder="Enter PAN Number"
            endButton={{
              label: "Validate",
              onClick: () => console.log("PAN Validate Clicked"),
            }}
          />
        </Grid>

        <Grid xs={6} marginTop="20px">
          <div className={styles.buttonContainer}>
            <CancelBtn buttonText={"Cancel"} />
            <SaveBtn buttonText={"Continue"} onClick={() => setIndex(3)} />
          </div>
        </Grid>
      </div>
    );
  };

  const renderIntegratedPage = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.integratedContainer}>
          <div className={styles.renderIntegratedHeadLine}>
            <div>Applicant Portfolio</div>
            <div>
              <img src={edufinEdit} height={"20px"} width={"20px"} />
            </div>
          </div>
          <div
            className={styles.renderIntegratedHeadLine}
            style={{
              margin: "20px 0px",
            }}
          >
            <div className={styles.boxes}>
              Name:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>Raghu</span>
            </div>
            <div className={styles.boxes}>
              Mobile:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>
                8892929292
              </span>
            </div>
            <div className={styles.boxes}>
              Email ID:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>
                djcn@jkd.cpm
              </span>
            </div>
          </div>
          <div className={styles.renderIntegratedSecondLine}>
            <div className={styles.boxes}>
              Adhar:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>
                983289982389
              </span>
            </div>
            <div className={styles.boxes}>
              Pan Card:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>
                9783289232
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.loanContainer}>
      <div>
        {index === 0
          ? renderIntro()
          : index === 1
          ? renderSignup()
          : index === 2
          ? renderKYC()
          : index === 3
          ? renderIntegratedPage()
          : ""}
      </div>
    </div>
  );
};

export default Profile;
